import testimonials from "@/data/testimonials";
import type { Testimonial as DisclosureQuote } from "@/data/testimonials/types";

const HERO_PATHS = new Set([
  "/",
  "/signin",
  "/login",
  "/signup",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/check-email",
  "/verify-email",
  "/auth/callback",
]);

let pickedQuote: DisclosureQuote | null = null;

/**
 * One image per full page load. Client-side navigation reuses it.
 * A reload clears the module and picks again.
 */
export function getHeroQuote(): DisclosureQuote {
  if (!pickedQuote) {
    const index = Math.floor(Math.random() * testimonials.length);
    pickedQuote = testimonials[index];
  }
  return pickedQuote;
}

export function isHeroPath(pathname: string): boolean {
  return HERO_PATHS.has(pathname);
}
